import React from 'react';
import { PedidoGroup } from '../../../Configuracion/types';
import './PedidoGroupsList.scss';
import { FaPlus, FaTrash, FaUsers } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

interface PedidoGroupsListProps {
  pedidoGroups: PedidoGroup[];
  selectedGroup?: PedidoGroup | null;
  onSelectGroup: (group: PedidoGroup) => void;
  onCreateGroup: () => Promise<void>;
  onDeleteGroup?: (groupId: number) => Promise<void>;
  creating: boolean;
  loading: boolean;
  newlyCreatedGroupId?: number | null;
}

const PedidoGroupsList: React.FC<PedidoGroupsListProps> = ({
  pedidoGroups,
  selectedGroup,
  onSelectGroup,
  onCreateGroup,
  onDeleteGroup,
  creating,
  loading,
  newlyCreatedGroupId,
}) => {

  const handleDelete = async (e: React.MouseEvent, groupId: number) => {
    e.stopPropagation(); // Prevent selecting the group when clicking delete
    
    if (onDeleteGroup) {
      await onDeleteGroup(groupId);
    }
  };

  if (loading) {
    return <div className="pedido-groups-list loading">Cargando grupos...</div>;
  }

  return (
    <div className="pedido-groups-list">
      <Button
        variant="primary"
        size="sm"
        onClick={onCreateGroup}
        disabled={creating}
        className="create-group-btn"
      >
        <FaPlus /> {creating ? 'Creando...' : 'Nuevo Grupo'}
      </Button>

      <div className="groups-container">
        {pedidoGroups.length === 0 ? (
          <div className="empty-state">
            <FaUsers className="empty-state__icon" />
            <p className="empty-state__title">No hay grupos activos</p>
            <p className="empty-state__hint">Haz clic en "Nuevo Grupo" para crear uno</p>
          </div>
        ) : (
          pedidoGroups.map((group) => {
            const isSelected = selectedGroup?.pedido_group_id === group.pedido_group_id;
            const isNewlyCreated = newlyCreatedGroupId === group.pedido_group_id;
            
            return (
              <div
                key={group.pedido_group_id}
                className={`group-pill ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelectGroup(group)}
              >
                <div className="group-pill__content">
                  <span className="group-pill__name">{group.name}</span>
                  {group.user_name && (
                    <span className="group-pill__user">{group.user_name}</span>
                  )}
                </div>
                {isNewlyCreated && onDeleteGroup && (
                  <button
                    className="group-pill__delete"
                    onClick={(e) => handleDelete(e, group.pedido_group_id)}
                    title="Eliminar grupo vacío"
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PedidoGroupsList;
